import { Box, Button, styled } from '@mui/material';

export const StripRecipient = styled('span', { name: 'ComposerStripRecipient' })(
  ({ theme }) => ({
    color: theme.palette.custom.OV.sys.onSurfaceVariant,
    fontWeight: 500,
  }),
);

export const OfferQuestion = styled(Box, { name: 'ComposerStripOfferQuestion' })(
  ({ theme }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',
    fontSize: '0.75rem',
    // font-native line box, so the question and the 11.5px buttons centre on the same line
    lineHeight: 'normal',
    color: theme.palette.custom.OV.sys.onSurfaceVariant,
    whiteSpace: 'nowrap',
  }),
);

export const OfferButton = styled(Button, {
  name: 'ComposerStripOfferButton',
  shouldForwardProp: (prop) => prop !== 'tone',
})<{ tone?: 'accept' }>(({ theme, tone }) => ({
  minWidth: 0,
  padding: '0.375rem 0.5625rem',
  borderRadius: '0.4375rem',
  fontSize: '0.71875rem',
  fontWeight: 700,
  letterSpacing: '0.02em',
  lineHeight: 'normal',
  textTransform: 'none',
  color: theme.palette.custom.OV.sys.onSurfaceVariant,
  '&:hover': {
    backgroundColor: theme.palette.custom.OV.sys.surfaceContainerHigh,
    color: theme.palette.custom.OV.sys.onBackground,
  },
  ...(tone === 'accept' && {
    color: theme.palette.custom.OV.sys.surfaceContainerLowest,
    backgroundColor: theme.palette.custom.OV.sys.tertiary,
    '&:hover': {
      backgroundColor: theme.palette.custom.OV.sys.tertiary,
      color: theme.palette.custom.OV.sys.surfaceContainerLowest,
      filter: 'brightness(1.07)',
    },
  }),
}));
